<div class="action-container">
  <!-- Top-level categories -->
  <div class="action-categories">
    <!-- Images category with its sub-options -->
    <div class="action-category-wrapper">
      <div class="action-category"
           [class.active]="selectedCategory === 'images'"
           (click)="onCategoryClick('images')">
        <div class="action-category__content">
          <div class="action-category__icon">
            <mat-icon>{{ getCategoryIcon('images') }}</mat-icon>
          </div>
          <div class="action-category__text">
            <div class="action-category__title">Images</div>
            <div class="action-category__subtitle" *ngIf="selectedCategory === 'images' && imagesSelectionLabel">
              • {{ imagesSelectionLabel }}
            </div>
          </div>
          <mat-icon class="action-category__caret" *ngIf="isImagesExpanded">expand_less</mat-icon>
          <mat-icon class="action-category__caret" *ngIf="!isImagesExpanded">expand_more</mat-icon>
        </div>
      </div>

      <!-- Sub-options for Images category -->
      <div class="action-sub-options" *ngIf="isImagesExpanded">
        <label class="action-sub-card"
               [class.selected]="selectedOption === 'images-sending'">
          <div class="action-sub-card__content">
            <div class="action-sub-card__icon">
              <mat-icon>cloud_upload</mat-icon>
            </div>
            <div class="action-sub-card__title">Send Images</div>
            <mat-checkbox
              color="primary"
              [checked]="selectedOption === 'images-sending'"
              (change)="onSubOptionToggle('images-sending', $event.checked)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </div>
        </label>

        <label class="action-sub-card"
               [class.selected]="selectedOption === 'images-retrieving'">
          <div class="action-sub-card__content">
            <div class="action-sub-card__icon">
              <mat-icon>cloud_download</mat-icon>
            </div>
            <div class="action-sub-card__title">Retrieve Images</div>
            <mat-checkbox
              color="primary"
              [checked]="selectedOption === 'images-retrieving'"
              (change)="onSubOptionToggle('images-retrieving', $event.checked)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </div>
        </label>
      </div>
    </div>

    <!-- Documents category with its sub-options -->
    <div class="action-category-wrapper">
      <div class="action-category"
           [class.active]="selectedCategory === 'documents'"
           (click)="onCategoryClick('documents')">
        <div class="action-category__content">
          <div class="action-category__icon">
            <mat-icon>{{ getCategoryIcon('documents') }}</mat-icon>
          </div>
          <div class="action-category__text">
            <div class="action-category__title">Documents</div>
            <div class="action-category__subtitle" *ngIf="selectedCategory === 'documents' && documentsSelectionLabel">
              • {{ documentsSelectionLabel }}
            </div>
          </div>
          <mat-icon class="action-category__caret" *ngIf="isDocumentsExpanded">expand_less</mat-icon>
          <mat-icon class="action-category__caret" *ngIf="!isDocumentsExpanded">expand_more</mat-icon>
        </div>
      </div>

      <!-- Sub-options for Documents category -->
      <div class="action-sub-options" *ngIf="isDocumentsExpanded">
        <label class="action-sub-card"
               [class.selected]="selectedOption === 'documents-sending'">
          <div class="action-sub-card__content">
            <div class="action-sub-card__icon">
              <mat-icon>cloud_upload</mat-icon>
            </div>
            <div class="action-sub-card__title">Send Documents</div>
            <mat-checkbox
              color="primary"
              [checked]="selectedOption === 'documents-sending'"
              (change)="onSubOptionToggle('documents-sending', $event.checked)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </div>
        </label>

        <label class="action-sub-card"
               [class.selected]="selectedOption === 'documents-retrieving'">
          <div class="action-sub-card__content">
            <div class="action-sub-card__icon">
              <mat-icon>cloud_download</mat-icon>
            </div>
            <div class="action-sub-card__title">Retrieve Documents</div>
            <mat-checkbox
              color="primary"
              [checked]="selectedOption === 'documents-retrieving'"
              (change)="onSubOptionToggle('documents-retrieving', $event.checked)"
              (click)="$event.stopPropagation()">
            </mat-checkbox>
          </div>
        </label>
      </div>
    </div>

    <!-- Patient Library category (no sub-options) -->
    <div class="action-category-wrapper">
      <div class="action-category action-category--disabled">
        <div class="action-category__content">
          <div class="action-category__icon">
            <mat-icon>{{ getCategoryIcon('patient-library') }}</mat-icon>
          </div>
          <div class="action-category__title">Patient Library</div>
          <mat-icon class="action-category__lock">lock</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
